import React from "react";
import { useSpring, animated, config } from "react-spring";
import { 
  FaFacebook, 
  FaInstagram, 
  FaPhone, 
  FaWhatsapp,
  FaYoutube 
} from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { FaBehanceSquare } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";





const Social = () => {
  // Animation for the container
  const containerAnimation = useSpring({
    from: { opacity: 0, right: -50 },
    to: { opacity: 1, right: 0 },
    config: config.slow,
    delay: 500
  });

  // Define icons data with their properties
  const iconsData = [

    { 
      icon: <FaPhone />, 
      color: "#25D366", 
      label: "Call Gotenberg Solution",
      url: "tel:+201114000025",
      delay: 1200
    },
    { 
      icon: <FaWhatsapp />, 
      color: "#25D366", 
      label: "WhatsApp Gotenberg Solution",
      url: "https://wa.me/+201114000025",
      delay: 1300
    },

    { 
      icon: <FaFacebook />, 
      color: "#3b5998", 
      label: "Follow Gotenberg Solution on Facebook",
      url: "https://www.facebook.com/profile.php?id=61582643616729",
      delay: 800
    },
        { 
      icon: <FaInstagram />, 
      color: "#E1306C", 
      label: "Follow Gotenberg Solution on Instagram",
      url: "https://www.instagram.com/goten_berg/",
      delay: 1000
    },
    { 
      icon: <FaYoutube />, 
      color: "#FF0000", 
      label: "Subscribe to Gotenberg Solution on YouTube",
      url: "https://www.youtube.com/@gotenbergnawas",
      delay: 1400
    },
         { 
      icon: <FaTiktok />, 
      color: "#25F4EE", 
      label: "Follow Gotenberg Solution on TikTok",
      url: "https://www.tiktok.com/@gotenberg_solution",
      delay: 1300
    },
    { 
      icon: <RiTwitterXLine />, 
      color: "#000000",
      label: "Follow Gotenberg Solution on X",
      url: "https://x.com/gotenberg_nawas",
      delay: 900
    },

    // { 
    //   icon: <FaAmazon />, 
    //   color: "#FF9900", 
    //   label: "Amazon",
    //   url: "https://amazon.com/yourshop",
    //   delay: 1100
    // },

      { 
      icon: <FaPinterest />, 
      color: "#E60023", 
      label: "Follow Gotenberg Solution on Pinterest",
      url: "https://www.pinterest.com/abohanfy73/",
      delay: 1100
    },
      { 
      icon: <FaBehanceSquare />, 
      color: "#1769FF", 
      label: "View Gotenberg Solution's Portfolio on Behance",
      url: "https://www.behance.net/abohanfy73?fbclid=IwY2xjawK55j5leHRuA2FlbQIxMABicmlkETFnT0tPd1VLQk9KNWFNS2lIAR7K-HFjsFVpipuudJbmwwqOrv0ZEbC4eMc_6Q72u3VYUol45gWrEWB4NFf-Og_aem_vO2Qa8H1PzH38IHkVXmJuQ",
      delay: 1200
    },

       
  ];

  // Create animations for each icon at the top level
  const facebookAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 800,
    config: config.gentle
  });
  const [facebookHover, facebookHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

  const twitterAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 900,
    config: config.gentle
  });
  const [twitterHover, twitterHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

  const instagramAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1000,
    config: config.gentle
  });
  const [instagramHover, instagramHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

  // const amazonAnim = useSpring({
  //   from: { transform: 'translateY(20px)', opacity: 0 },
  //   to: { transform: 'translateY(0)', opacity: 1 },
  //   delay: 1100,
  //   config: config.gentle
  // });
  // const [amazonHover, amazonHoverApi] = useSpring(() => ({
  //   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  //   scale: 1
  // }));

  const phoneAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1100,
    config: config.gentle
  });
  const [phoneHover, phoneHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

  const whatsappAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1200,
    config: config.gentle
  });
  const [whatsappHover, whatsappHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

    const PinterestAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1300,
    config: config.gentle
  });
  const [PinterestHover, PinterestHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

      const BehanceAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1400,
    config: config.gentle
  });
  const [BehanceHover, BehanceHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

        const TiktokAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1500,
    config: config.gentle
  });
  const [TiktokHover, TiktokHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

          const YoutubeAnim = useSpring({
    from: { transform: 'translateY(20px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    delay: 1600,
    config: config.gentle
  });
  const [YoutubeHover, YoutubeHoverApi] = useSpring(() => ({
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    scale: 1
  }));

  // Combine all animations and APIs for easier access
  const iconAnimations = [
    { anim: facebookAnim, hover: facebookHover, api: facebookHoverApi },
    { anim: twitterAnim, hover: twitterHover, api: twitterHoverApi },
    { anim: instagramAnim, hover: instagramHover, api: instagramHoverApi },
    { anim: phoneAnim, hover: phoneHover, api: phoneHoverApi },
    { anim: whatsappAnim, hover: whatsappHover, api: whatsappHoverApi },
    { anim: PinterestAnim, hover: PinterestHover, api: PinterestHoverApi },
    { anim: BehanceAnim, hover: BehanceHover, api: BehanceHoverApi },
    { anim: TiktokAnim, hover: TiktokHover, api: TiktokHoverApi },
    { anim: YoutubeAnim, hover: YoutubeHover, api: YoutubeHoverApi },
  ];

  return (
    <animated.div 
      style={{
        ...containerAnimation,
        position: "fixed",
        right: "20px",
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
        zIndex: 1000,
      }}
    >
      {iconsData.map((item, index) => (
        <animated.a
          key={index}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            ...iconAnimations[index].anim,
            ...iconAnimations[index].hover,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "45px",
            height: "45px",
            borderRadius: "50%",
            backgroundColor: "#F8F7FF",
            color: item.color,
            fontSize: "24px",
            textDecoration: "none",
            cursor: "pointer",
          }}
          onMouseEnter={() => {
            iconAnimations[index].api.start({
              transform: 'translateY(-5px)',
              boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
              scale: 1.1,
              immediate: false
            });
          }}
          onMouseLeave={() => {
            iconAnimations[index].api.start({
              transform: 'translateY(0)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              scale: 1,
              immediate: false
            });
          }}
          aria-label={item.label}
          title={item.label}
        >
          {item.icon}
        </animated.a>
      ))}
    </animated.div>
  );
};

export default Social;